import Vue from 'vue'
import axios from 'axios'
import { extractData } from '@/utils'
import { workspaceUrls } from '@/api/urls'
import { Visualizations } from '@/api'

const options = { headers: {'Content-Type': 'application/json'}, withCredentials: true }

const temporaryWorkspaceTitle = (visualizationName) => `${Vue.i18n.translate('temporary workspace prefix')} - ${visualizationName}`

const buildManagerId = (view) => `r_${view.Id}`

const buildReportObject = (view) => ({ title: view.Name, managerId: buildManagerId(view) })

const getViewList = () => {
  return axios.get(workspaceUrls.getViewList(), options)
    .then(extractData)
}

export const getReportList = async () => {
  const viewList = await getViewList()
  return viewList.Categories[0].Results.Results.map(view => buildReportObject(view))
}

export const getNewWorkspaceId = (userId, title = null) => {
  const payload = {
    Name: title || Vue.i18n.translate('untitled workspace')
  }
  return axios.post(workspaceUrls.newWorkspaceReq(userId), payload, options)
}

export const addVisualizationToWorkspace = (userId, workspaceId, pageId, visualizationId) => {
  const payload = {
    Title: Vue.i18n.translate('untitled page'),
    Token: pageId,
    Views: [{ Visualization: { Id: visualizationId } }]
  }
  return axios.put(workspaceUrls.addVisualizationToWorkspace(userId, workspaceId, pageId), payload, options)
}

export const createTemporaryWorkspaceWithVisualization = async (userId, visualizationId) => {
  try {
    // Get Visualization
    const visualization = await Visualizations.getVisualization(visualizationId)
    // Extract Visualization Info
    const name = visualization.data.Title
    const title = temporaryWorkspaceTitle(name)
    // Create Workspace
    const workspace = await getNewWorkspaceId(userId, title)
    // Extract Workspace Info
    const workspaceId = workspace.data.Id
    const pageId = workspace.data.FirstPage.Token
    // Add Visualization to Workspace
    const page = await addVisualizationToWorkspace(userId, workspaceId, pageId, visualizationId)
    // Completed
    return workspaceId
  } catch (err) {
    // Rethrow
    throw err
  }
}

export const getWorkspace = (userId, workspaceId) => {
  return axios.get(workspaceUrls.getWorkspace(userId, workspaceId), options)
}

export const getAllWorkspaces = (userId, max=20) => {
  return axios.get(workspaceUrls.getAllWorkspaces(userId, max), options)
}

export default {
  getReportList,
  getNewWorkspaceId,
  addVisualizationToWorkspace,
  createTemporaryWorkspaceWithVisualization,
  getWorkspace,
  getAllWorkspaces
}
